
import * as React from "react";
import {
  Box,
  Button,
  Chip,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useContext, useEffect, useMemo, useState } from "react";
import { MapContainer, Marker, Polygon, TileLayer } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import markerIcon from "leaflet/dist/images/marker-icon.png";
import markerIcon2x from "leaflet/dist/images/marker-icon-2x.png";
import markerShadow from "leaflet/dist/images/marker-shadow.png";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  deleteRequest,
  getRequestWithToken,
} from "../../../utils/ApiRequests";
import { GlobalContext } from "../../../components/GlobalStateProvide/GlobalStateProvider";
import ReusableLoader from "../../../components/ReusableLoader/ReusableLoader";
import SureYouWantToDeletModal from "../../../components/SureYouWantToDeleteModal/SureYouWantToDeletModal";
import { checkPermission } from "../../../utils/userPermissions";
import Unauthorized from "../../../components/unauthorized/Unauthorized";
import ModalComponent from "../../../components/ModalComponent/ModalComponent";

import PropTypes from "prop-types";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";

const RegionMapping = () => {
  const [employerData, setEmployerData] = useState([]);
  const navigate = useNavigate();
  const { handleSnackBar } = useContext(GlobalContext);
  const [showLoader, setShowLoader] = useState(true);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [candidateId, setCandidateId] = useState("");
  const [rowCount, setRowCount] = useState(0);
  const [loadingDataInGrid, setLoadingDataInGrid] = useState(null);
  const [canCreate, setCanCreate] = useState(false);
  const [canDelete, setCanDelete] = useState(false);
  const [canUpdate, setCanUpdate] = useState(false);
  const [canRead, setCanRead] = useState(false);
  const [openUserCountModal, setOpenUserCountModal] = useState(false);
  const [selectedMapping, setSelectedMapping] = useState(null);
  const [regionUserCountData, setRegionUserCountData] = useState(null);
  const [isFetchingUserCount, setIsFetchingUserCount] = useState(false);

  const [isAccess, setisAccess] = useState([]);
  const [isIncludesValue, setisIncludesValue] = useState(null);

  const [tabvalue, setTabValue] = useState(0);


  const [columnFilters, setColumnFilters] = useState([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState([]);
  const [isRefetching, setIsRefetching] = useState(false);
  const [isError, setIsError] = useState(false);


  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 100,
  });

  const createNewRegion = () => {
    navigate("/create-region-mapping");
  };

  const [showDeletedRows, setShowDeletedRows] = useState(true);

  useEffect(() => {
    L.Icon.Default.mergeOptions({
      iconUrl: markerIcon,
      iconRetinaUrl: markerIcon2x,
      shadowUrl: markerShadow,
    });
  }, []);

  const polygonPositions = useMemo(() => {
    const polygon = selectedMapping?.region_id?.polygon;
    if (!polygon?.coordinates?.length) {
      return [];
    }

    if (polygon.type === "MultiPolygon") {
      return polygon.coordinates.map((multiPolygon) =>
        (multiPolygon[0] || []).map(([lng, lat]) => [lat, lng])
      );
    }

    return (polygon.coordinates[0] || []).map(([lng, lat]) => [lat, lng]);
  }, [selectedMapping?.region_id?.polygon]);

  const mapCenter = useMemo(() => {
    if (Array.isArray(polygonPositions) && polygonPositions.length > 0) {
      if (Array.isArray(polygonPositions[0][0])) {
        return polygonPositions[0][0];
      }
      return polygonPositions[0];
    }
    return [20.5937, 78.9629];
  }, [polygonPositions]);

  const regionUserMarkers = useMemo(() => {
    const users = regionUserCountData?.users || [];
    return users
      .map((user) => {
        const coordinates = user?.location?.coordinates;
        if (!coordinates || coordinates.length !== 2) {
          return null;
        }
        const [lng, lat] = coordinates;
        return { id: user._id, position: [lat, lng] };
      })
      .filter(Boolean);
  }, [regionUserCountData]);

  const handleOpenUserCountModal = async (mapping) => {
    if (!mapping?.region_id?._id || !mapping?.form_id?._id) {
      handleSnackBar(true, "Region or form mapping is missing", "error");
      return;
    }

    setSelectedMapping(mapping);
    setOpenUserCountModal(true);
    setIsFetchingUserCount(true);

    try {
      const response = await getRequestWithToken(
        `/admin/plus/regions/${mapping.region_id._id}/user-count?formId=${mapping.form_id._id}`
      );
      setRegionUserCountData(response?.data?.data || null);
    } catch (error) {
      handleSnackBar(
        true,
        error?.response?.data?.msg || error?.message,
        "error"
      );
      setRegionUserCountData(null);
    } finally {
      setIsFetchingUserCount(false);
    }
  };

  const handleToggleChange = () => {
    setShowDeletedRows(!showDeletedRows);
  };



  const columns = [
    {
      accessorKey: "id",
      header: "S.No.",
      size: 50,
      enableColumnFilter: false,
      Cell: ({ row, table }) => {
        const pageIndex = table.getState().pagination.pageIndex;
        const pageSize = table.getState().pagination.pageSize;
        const rowIndex = row.index;
        return <span>{rowIndex + 1 + pageIndex * pageSize}</span>;
      },
    },
    {
      header: "Region Name",
      size: 150,
      id: 'name',
      accessorKey: "name",
      Cell: ({ row }) => {
        return <span>{row.original?.region_id?.name}</span>;
      }
    },
    {
      header: "Role Name",
      size: 150,
      id: 'rolename',
      accessorKey: "rolename",
      Cell: ({ row }) => {
        return <span>{row.original?.form_id?.role}</span>;
      }
    },
    {
      header: "PHC",
      size: 100,
      id: 'phc',
      accessorKey: "phc",
    },


    {
      accessorKey: "createdAt",
      header: "Created At",
      size: 200,
      enableColumnFilter: false,
      Cell: ({ cell }) => (
        <span>
          {new Date(cell.getValue()).toLocaleString("en-US", {
            timeZone: "Asia/Kolkata",
          })}
        </span>
      ),
    },


    {
      accessorKey: "z_action",
      header: "Action",
      size: 280,
      enableColumnFilter: false,
      Cell: ({ row }) =>
        row.original.deleted?.is_deleted ? (
          <Box style={{ display: "flex", gap: "2rem" }}>
            {canUpdate && <EditIcon color="disabled" />}
            {canDelete && <DeleteIcon color="disabled" />}
          </Box>
        ) : (
          <Box style={{ display: "flex", gap: "2rem" }}>
            {/* {canRead && (
              <Tooltip title="View">
                <VisibilityIcon
                  sx={{ cursor: "pointer" }}
                  color="primary"
                  onClick={() =>
                    window.open(`/jobs-by-locations/view/${row.original._id}`, "_blank")
                  }

                />
              </Tooltip>
            )} */}

            {canUpdate && (
              <EditIcon
                sx={{ cursor: "pointer" }}
                color="primary"
                onClick={() =>
                  navigate("/create-region-mapping", { state: row.original })
                }
              />
            )}
            {canRead && (
              <Button
                variant="outlined"
                size="small"
                sx={{ minWidth: "140px" }}
                onClick={() => handleOpenUserCountModal(row.original)}
              >
                View Data Count
              </Button>
            )}
            {canDelete && (
              <DeleteIcon
                sx={{ cursor: "pointer" }}
                color="error"
                onClick={() => {
                  setOpenDeleteModal(true);
                  setCandidateId(row.original._id);
                }}
              />
            )}
          </Box>
        ),
    },

  ];

  const deleteEmployer = async () => {


    try {
      let response = await deleteRequest(
        `admin/region-form-mappings/${candidateId}`
      );

      handleSnackBar(true, response?.data?.msg, "success");
      setOpenDeleteModal(false);
      setShowLoader(true);
      getAllEmployers();
    } catch (err) {
      handleSnackBar(true, err?.response?.data?.msg, "error");
      setOpenDeleteModal(false);
    }
  };

  const getAllEmployers = async () => {
    setLoadingDataInGrid(true);
    try {
      if (tabvalue === 0) {
        let response = await getRequestWithToken(
          `/admin/region-form-mappings?page=${pagination.pageIndex + 1}&limit=${pagination.pageSize
          }`
        );
        // setRowCount(response?.data?.data.totalCount);
        setEmployerData(response?.data.data.mappings);
        setLoadingDataInGrid(false);
        setShowLoader(false);
      }
    } catch (error) {
      handleSnackBar(
        true,
        error?.response?.data?.msg || error?.message,
        "error"
      );
      setLoadingDataInGrid(false);
      setShowLoader(false);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      if (!employerData?.length) {
        setLoadingDataInGrid(true);
      } else {
        setIsRefetching(true);
      }

      try {
        let filterParams = {
          // global: globalFilter,
          ...Object.fromEntries(
            columnFilters.map((filter) => [filter.id, filter.value])
          ),
        };
        if ("type" in filterParams) {
          filterParams["type"] = filterParams["type"] === "phc" ? 2 : 1;
        }
        // if(filterParams[key])

        const filterQueryString = new URLSearchParams(filterParams).toString();

        // const response = await getRequestWithToken(
        //   `/admin/addon?&page=${pagination.pageIndex + 1}&limit=${pagination.pageSize}&${filterQueryString}`
        // );
        const response = await getRequestWithToken(
          `/admin/region-form-mappings?${filterQueryString}&page=1&limit=100`
        );

        setEmployerData(response?.data.data.mappings);
        // setRowCount(response?.data?.data.totalCount);
        setIsError(false);
        setLoadingDataInGrid(false);
        setShowLoader(false);
      } catch (error) {
        setIsError(true);
        handleSnackBar(
          true,
          error?.response?.data?.message || error?.message,
          "error"
        );
        setLoadingDataInGrid(false);
      }
      setLoadingDataInGrid(false);
      setIsRefetching(false);
      setShowLoader(false);
    };
    fetchData();
  }, [
    columnFilters,
    globalFilter,
    pagination.pageIndex,
    pagination.pageSize,
    sorting,
  ]);

  const checkPermissionFunc = () => {
    const resourceToUpdate = "HC-Addon";
    const permissions = checkPermission(resourceToUpdate);
    setCanCreate(permissions.canCreate);
    setCanDelete(permissions.canDelete);
    setCanUpdate(permissions.canUpdate);
    setCanRead(permissions.canRead);
  };

  const againCheckPermissions = () => {
    const checkAccesInArray = localStorage.getItem("resourceNames");
    setisAccess(checkAccesInArray);
    isIncludes();
  };

  const isIncludes = () => {
    setisIncludesValue(isAccess.includes("HC-Addon"));
  };

  useEffect(() => {
    checkPermissionFunc();
    againCheckPermissions();
  }, [
    isIncludesValue,
    tabvalue,
  ]);

  function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            <Box>{children}</Box>
          </Box>
        )}
      </div>
    );
  }

  CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
  };

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }

  const currentTabSelect = (event, newValue) => {
    setTabValue(newValue);
  };


  const table = useMaterialReactTable({
    columns,
    data: employerData,
    initialState: { showColumnFilters: false },
    manualFiltering: true,
    manualPagination: true,
    enableBottomToolbar: false,

    manualSorting: true,
    enableStickyHeader: true,
    enableStickyFooter: true,
    enableColumnPinning: true,
    enableColumnResizing: true,
    enableGlobalFilter: false,
    enableSorting: false,
    muiSkeletonProps: {
      animation: "wave",
    },
    muiLinearProgressProps: {
      style: {
        backgroundColor: "#ff671f", // Custom orange color
      },
    },
    muiCircularProgressProps: {
      color: "secondary",
    },
    muiToolbarAlertBannerProps: isError
      ? {
        color: "error",
        children: "No Data",
      }
      : undefined,
    onColumnFiltersChange: setColumnFilters,
    onGlobalFilterChange: setGlobalFilter,
    onPaginationChange: setPagination,
    onSortingChange: setSorting,
    state: {
      columnFilters,
      globalFilter,
      isLoading: loadingDataInGrid,
      pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      sorting,
    },
    // renderBottomToolbarCustomActions: ({ table }) => {
    //   const { pageIndex, pageSize } = table.getState().pagination;
    //   const totalPages = Math.ceil(rowCount / pageSize);
    //   return (
    //     <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
    //       <Typography variant="body2" style={{ marginLeft: "10px" }}>
    //         Page {pageIndex + 1} of {totalPages}
    //       </Typography>
    //     </Box>
    //   );
    // },
    renderTopToolbarCustomActions: ({ table }) => {
      const pinnedColumns = table.getState().columnPinning;
      return (
        <Box>
          <Chip
            label={`Left Pinned: ${pinnedColumns?.left?.length}`}
            color="primary"
            sx={{ mr: 1 }}
          />
          <Chip
            label={`Right Pinned: ${pinnedColumns?.right?.length}`}
            color="secondary"
          />
        </Box>
      );
    },
  });

  return isIncludesValue ? (
    <Box className="employers-section">

      <Box
        className="employers-top-section"
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        {canCreate ? (
          <Button
            variant="contained"
            color="success"
            onClick={createNewRegion}
          >
            Create Mapping
          </Button>
        ) : (
          ""
        )}

        {/* <FormGroup>
          <FormControlLabel control={<Switch checked={showDeletedRows} onChange={handleToggleChange} />} label="Include Deleted Users" labelPlacement="start" />
        </FormGroup> */}
      </Box>

      <Box sx={{ width: "100%" }}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          {/* <Tabs
            value={tabvalue}
            onChange={currentTabSelect}
            aria-label="basic tabs example"
          >
            <Tab
              label="All Locations"
              style={{ fontWeight: "700" }}
              {...a11yProps(0)}
            />
          </Tabs> */}
        </Box>

        {showLoader ? <ReusableLoader /> : <MaterialReactTable table={table} />}
      </Box>

      <SureYouWantToDeletModal
        modalTitle=""
        dialogBody="Are you sure you want to delete this Mapping?"
        buttonText="Yes"
        openDeleteModal={openDeleteModal}
        setOpenDeleteModal={setOpenDeleteModal}
        onYesClick={() => {
          deleteEmployer();
        }}
      />
      <ModalComponent
        openModal={openUserCountModal}
        setOpenModal={setOpenUserCountModal}
        modalTitle="Region Data Count"
        modalWidth="70%"
        handleOnCloseBtnClick={() => {
          setOpenUserCountModal(false);
          setRegionUserCountData(null);
          setSelectedMapping(null);
        }}
      >
        <Box style={{ padding: "16px" }}>
          {isFetchingUserCount ? (
            <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
              <ReusableLoader />
            </Box>
          ) : (
            <>
              <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
                <h3 style={{ margin: 0 }}>Total Plus Users</h3>
                <Box
                  sx={{
                    backgroundColor: "#ffefe6",
                    color: "#ff671f",
                    fontWeight: 700,
                    padding: "6px 16px",
                    borderRadius: "16px",
                    fontSize: "18px",
                  }}
                >
                  {regionUserCountData?.userCount || 0}
                </Box>
              </Box>

              {regionUserCountData?.userCount === 0 ? (
                <Box sx={{ textAlign: "center", py: 6 }}>
                  <p style={{ margin: 0 }}>No Plus users found inside this region for the selected form.</p>
                </Box>
              ) : (
                <Box sx={{ height: "400px", width: "100%", borderRadius: "8px", overflow: "hidden" }}>
                  {polygonPositions.length > 0 ? (
                    <MapContainer center={mapCenter} zoom={11} style={{ height: "100%", width: "100%" }}>
                      <TileLayer
                        attribution="&copy; OpenStreetMap contributors"
                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                      />
                      {Array.isArray(polygonPositions[0]) && Array.isArray(polygonPositions[0][0]) ? (
                        polygonPositions.map((polygon, index) => (
                          <Polygon key={`polygon-${index}`} positions={polygon} pathOptions={{ color: "#ff671f" }} />
                        ))
                      ) : (
                        <Polygon positions={polygonPositions} pathOptions={{ color: "#ff671f" }} />
                      )}
                      {regionUserMarkers.map((marker) => (
                        <Marker key={marker.id} position={marker.position} />
                      ))}
                    </MapContainer>
                  ) : (
                    <Box sx={{ textAlign: "center", py: 6 }}>
                      <p style={{ margin: 0 }}>Region polygon is not available.</p>
                    </Box>
                  )}
                </Box>
              )}
            </>
          )}
        </Box>
      </ModalComponent>
    </Box>
  ) : (
    <Unauthorized />
  );
};
export default RegionMapping;
